import store from '../store';
import { v4 as uuidv4 } from 'uuid';
import userModel from '../models/userModel';

export default function addUserByUserType(identifier) {
    const products = store.state.cart.products;
    const newUser = userModel();

    newUser.id = uuidv4();
    newUser.identifier = identifier;

    store.dispatch('cart/addUser', newUser);
    store.dispatch('cart/addItemForUserWithoutProduct', newUser);

    if (products.length > 0) store.dispatch('cart/updateProductForAllUsers', products[0]);
}
